import * as React from "react";
const SvgFreshservice = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#09C6FA",
  d: "M15.478 2c1.3 0 2.6.004 3.9 0 .657-.005 1.242.17 1.738.607.546.478.862 1.078.865 1.803.01 2.636.04 5.272-.008 7.907-.045 2.372-.894 4.466-2.459 6.252-1.635 1.868-3.694 2.981-6.153 3.329a9.65 9.65 0 0 1-5.492-.802c-2.441-1.123-4.166-2.95-5.17-5.437a9.6 9.6 0 0 1-.641-4.674 9.9 9.9 0 0 1 2.43-5.575C5.84 3.867 7.513 2.84 9.494 2.32A10 10 0 0 1 12.082 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFEFE",
  d: "M13.861 11.113c.878 0 1.755.003 2.633-.002.203 0 .361.06.457.242s.039.34-.073.494l-4.455 6.165-.06.082c-.15.188-.29.227-.456.136-.165-.09-.199-.23-.124-.459l1.24-3.776c.097-.298.09-.3-.214-.3H7.747q-.112 0-.224-.002c-.175-.007-.318-.07-.396-.238a.43.43 0 0 1 .05-.46q.63-.865 1.254-1.736 1.572-2.183 3.14-4.373c.059-.083.116-.167.181-.247.114-.142.264-.175.419-.088s.208.227.151.4l-.658 2.015c-.214.652-.422 1.306-.643 1.956-.058.167-.008.195.148.194.896-.006 1.794-.003 2.692-.003"
}));
export default SvgFreshservice;
//# sourceMappingURL=Freshservice.js.map